import { money } from '../helpers'

export function useToppingPriceLabel(topping: ItemTopping): string {
  if (topping.is_included) {
    return 'Included'
  }

  if (topping.price <= 0) {
    return 'Free'
  }

  return money(topping.price)
}
